import React from "react"
import { connect } from "react-redux"

import {
  getDeviceSummaryDetails,
  getPlanSummaryDetails,
  getExtrasSummaryDetails,
  getTotalCosts,
  getSwappableBenefits,
  hasSwappableBenefits
} from "redux/selectors/basket-selectors"
import {
  addExtra,
  removeExtra,
  addBenefit,
  removeBenefit
} from "redux/actions/basket-actions"
import { firstPage, nextPage } from "redux/actions/journey-actions"
import { getExtrasForSelectedPhone } from "redux/selectors/extras-selector"
import { getSelectedPlanName } from "redux/selectors/plan-selectors"

import SummaryBox from "components/summary/summary-box"
import ExtrasList from "components/choose-extras/extras-list"
import SwappableBenefitsList from "components/choose-swappable-benefit/swappable-benefits-list"
import Button from "components/shared/button/text-button"
import { useEFSData } from "hooks/efs-input"
import StringInject from "stringinject"

const SummaryExtrasPage = ({
  planName,
  deviceSummary,
  planSummary,
  extrasSummary,
  totalCosts,
  gotoFirstPage,
  gotoNextPage,
  excludeVAT,
  vatDivider,
  deviceExtras,
  deviceSwappableBenefits,
  selectedExtras,
  selectedBenefits,
  addExtra,
  removeExtra,
  addBenefit,
  removeBenefit,
  numberOfSwappableBenefits,
  hasSwappableBenefits
}) => {
  const { haveHalo } = useEFSData()

  const templateData = {
    currentHalo: haveHalo === 1 ? "+ Halo 1" : " ",
    haloUpgrade: haveHalo === 1 ? "+ Halo 3" : "+ Halo 1"
  }

  planName = StringInject(planName, templateData)

  return (
    <>
      <div className="summary-page">
        <SummaryBox
          planName={planName}
          deviceSummary={deviceSummary}
          planSummary={planSummary}
          totalCosts={totalCosts}
        />
      </div>

      {hasSwappableBenefits && (
        <SwappableBenefitsList
          benefits={deviceSwappableBenefits}
          onAddBenefit={addBenefit}
          onRemoveBenefit={removeBenefit}
          selectedBenefits={selectedBenefits}
          excludeVAT={excludeVAT}
          numberOfSwappableBenefits={numberOfSwappableBenefits}
        />
      )}

      <ExtrasList
        extras={deviceExtras}
        onAddExtra={addExtra}
        onRemoveExtra={removeExtra}
        selectedExtras={selectedExtras}
        excludeVAT={excludeVAT}
      />
      <div className="continue-button">
        <Button text="Continue" onClick={() => gotoNextPage()} />
      </div>

      {/* <SummaryButtons
      onEmptyBasket={gotoFirstPage}
      numberOfSwappableBenefits={numberOfSwappableBenefits}
      selectedBenefits={selectedBenefits}
    /> */}
    </>
  )
}

const mapStateToProps = state => ({
  deviceExtras: getExtrasForSelectedPhone(state),
  deviceSwappableBenefits: getSwappableBenefits(state),
  selectedExtras: state.basket.extras,
  selectedBenefits: state.basket.benefits,
  planID: state.basket.planID,
  deviceSummary: getDeviceSummaryDetails(state),
  planSummary: getPlanSummaryDetails(state),
  extrasSummary: getExtrasSummaryDetails(state),
  totalCosts: getTotalCosts(state),
  excludeVAT: state.plans.options.excludeVAT,
  vatDivider: state.plans.options.vatDivider,
  plans: state.plans,
  hasSwappableBenefits: hasSwappableBenefits(state),
  planName: getSelectedPlanName(state),
  numberOfSwappableBenefits:
    !state.basket.builtPlan &&
    state.plans.byID[state.basket.planID].swappableBenefits &&
    state.plans.byID[state.basket.planID].swappableBenefits.amount
})

const mapDispatchToProps = dispatch => ({
  gotoFirstPage: () => dispatch(firstPage()),
  gotoNextPage: () => dispatch(nextPage()),
  addExtra: id => dispatch(addExtra(id)),
  removeExtra: id => dispatch(removeExtra(id)),
  addBenefit: id => dispatch(addBenefit(id)),
  removeBenefit: id => dispatch(removeBenefit(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(SummaryExtrasPage)
